import type { App } from 'vue'
import AppInput from './app-input.vue'
import AppInputAutocomplete from './app-input-autocomplete.vue'
import AppInputCheckbox from './app-input-checkbox.vue'
import AppInputDate from './app-input-date.vue'
import AppInputDatepicker from './app-input-datepicker.vue'
import AppInputFile from './app-input-file.vue'
import AppInputNumber from './app-input-number.vue'
import AppInputPercent from './app-input-percent.vue'
import AppInputOtp from './app-input-otp.vue'
import AppInputPassword from './app-input-password.vue'
import AppInputPeriode from './app-input-periode.vue'
import AppInputSearch from './app-input-search.vue'
import AppInputSelect from './app-input-select.vue'
import AppInputSwitch from './app-input-switch.vue'
import AppInputTel from './app-input-tel.vue'

export const useInput = {
  install (app: App) {
    app.component('AppInputCheckbox', AppInputCheckbox)
    app.component('AppInputDate', AppInputDate)
    app.component('AppInputPeriode', AppInputPeriode)
    app.component('AppInputDatepicker', AppInputDatepicker)
    app.component('AppInputFile', AppInputFile)
    app.component('AppInputNumber', AppInputNumber)
    app.component('AppInputPercent', AppInputPercent)
    app.component('AppInputOtp', AppInputOtp)
    app.component('AppInputPassword', AppInputPassword)
    app.component('AppInputSearch', AppInputSearch)
    app.component('AppInputSelect', AppInputSelect)
    app.component('AppInputSwitch', AppInputSwitch)
    app.component('AppInputTel', AppInputTel)
    app.component('AppInputAutocomplete', AppInputAutocomplete)
    app.component('AppInput', AppInput)
  },
}

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    AppInputCheckbox: typeof AppInputCheckbox,
    AppInputDate: typeof AppInputDate,
    AppInputPeriode: typeof AppInputPeriode,
    AppInputDatepicker: typeof AppInputDatepicker,
    AppInputFile: typeof AppInputFile,
    AppInputNumber: typeof AppInputNumber,
    AppInputPercent: typeof AppInputPercent,
    AppInputOtp: typeof AppInputOtp,
    AppInputPassword: typeof AppInputPassword,
    AppInputSearch: typeof AppInputSearch,
    AppInputSelect: typeof AppInputSelect,
    AppInputSwitch: typeof AppInputSwitch,
    AppInputTel: typeof AppInputTel,
    AppInputAutocomplete: typeof AppInputAutocomplete,
    AppInput: typeof AppInput,
  }
}
